export default "__VITE_ASSET__2b798549__"